import { z } from 'zod'

export const ExternalAuthDto = z.object({
  firebaseAuthToken: z.string().optional(),
  linkToken: z.string().optional(),
  email: z.string().email(),
})
